import { render, staticRenderFns } from "./TaskReportsPage.vue?vue&type=template&id=4b5ffc5e&scoped=true"
import script from "./TaskReportsPage.vue?vue&type=script&lang=js"
export * from "./TaskReportsPage.vue?vue&type=script&lang=js"
import style0 from "../task-reports.scss?vue&type=style&index=0&id=4b5ffc5e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ffc5e",
  null
  
)

export default component.exports